export default __webpack_public_path__ + "static/media/ecomerce.bc6ab166.webp";